(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;

  function init(scope) {
    scope.querySelectorAll('[data-pwb-motion]').forEach(root => {
      if (root.dataset.motionInitialized) return;
      root.dataset.motionInitialized = 'true';
      if (reducedMotion.matches) return;
      const animations = new Map();
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          animations.get(entry.target)?.play();
          observer.unobserve(entry.target);
        });
      }, { threshold: 0, rootMargin: '0px 0px 100px 0px' });

      root.querySelectorAll('[data-pwb-reveal]').forEach(element => {
        const animation = element.animate([
          { opacity: 0, transform: 'translate3d(0, 100px, 0)' },
          { opacity: 1, transform: 'translate3d(0, 0, 0)' }
        ], {
          duration: Number(element.dataset.pwbReveal),
          delay: Number(element.dataset.pwbDelay || 0),
          easing: 'ease', fill: 'both'
        });
        animation.pause();
        animation.onfinish = () => {
          animation.cancel();
          animations.delete(element);
        };
        animations.set(element, animation);
        observer.observe(element);
      });

      root.addEventListener('focusin', event => {
        animations.forEach((animation, element) => {
          if (element.contains(event.target)) animation.finish();
        });
      });
      reducedMotion.addEventListener('change', event => {
        if (!event.matches) return;
        observer.disconnect();
        animations.forEach(animation => animation.finish());
      }, { once: true });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
